module.exports = __webpack_public_path__ + "static/media/5-1.313b3b98.jpg";